<script>
    import {
        CalendarMonthOutline,
        ClockOutline,
        ClockSolid, FileLinesOutline,
        FileLinesSolid, FileOutline,
        GlobeOutline,
        GlobeSolid,
        UsersGroupOutline,
        UsersSolid
    } from "flowbite-svelte-icons"

    export let cardIcon

</script>

{#if cardIcon === "Jahresumsatz"}
    <CalendarMonthOutline class="text-primary-600 w-20 h-20" />
{:else if cardIcon === "Garantie"}
    <ClockOutline  class="text-primary-600 w-20 h-20" />
{:else if cardIcon === "Volumen"}
    <UsersGroupOutline  class="text-primary-600 w-20 h-20" />
{:else if cardIcon === "Exklusivität"}
    <FileLinesOutline  class="text-primary-600 w-20 h-20" />
{/if}
